import React from 'react';
import useAppContext from 'flow/hooks/useAppContext';

const SenderSystem = () => {
    const { i18next } = useAppContext();
    return <span>{i18next.t('Queue.Settings.List.WelcomeMessage')}</span>;
};

export default SenderSystem;
